import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jurassic",
  "use": "icon-jurassic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-jurassic\"><defs><style type=\"text/css\"></style></defs><path d=\"M376.3 64h280.3v224H376.3zM96 792h168.2v168H96zM432.4 792h168.2v168H432.4zM708.7 788v171H928V788H708.7z m155.2 107h-91.1v-43h91.1v43zM212.1 516h272.4v220h64V516h272.4v220h64V452H548.5V344h-64v108H148.1v284h64z\" fill=\"#727272\" p-id=\"4985\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol